import { useState } from 'react'
import { X, Image } from 'lucide-react'
import { useAuth } from '../../../context/AuthContext'
import ImagePicker from './ImagePicker'

export default function BulkImageModal({ tbtvIds, onClose, onComplete, setStatus }) {
  const { api } = useAuth()
  const [thumbnailUrl, setThumbnailUrl] = useState('')
  const [processing, setProcessing] = useState(false)
  const [progress, setProgress] = useState({ done: 0, total: 0, errors: 0 })

  async function handleApply() {
    if (!thumbnailUrl.trim()) return
    setProcessing(true)
    setProgress({ done: 0, total: tbtvIds.length, errors: 0 })

    let errors = 0
    for (let i = 0; i < tbtvIds.length; i++) {
      try {
        await api(`/vod/${tbtvIds[i]}`, {
          method: 'PATCH',
          body: JSON.stringify({ thumbnail_url: thumbnailUrl.trim() })
        })
      } catch {
        errors++
      }
      setProgress({ done: i + 1, total: tbtvIds.length, errors })
    }

    setProcessing(false)
    if (setStatus) {
      const ok = tbtvIds.length - errors
      setStatus(errors > 0
        ? `Set thumbnail on ${ok} item(s) (${errors} failed)`
        : `✅ Thumbnail set on ${tbtvIds.length} item(s)`)
    }
    if (onComplete) onComplete()
  }

  return (
    <div className="bulk-modal-overlay" onClick={onClose}>
      <div className="bulk-modal" onClick={e => e.stopPropagation()}>
        <div className="bulk-modal-header">
          <Image size={16} />
          <h3>Set Thumbnail - {tbtvIds.length} item{tbtvIds.length !== 1 ? 's' : ''}</h3>
          <button onClick={onClose} className="bulk-modal-close"><X size={16} /></button>
        </div>

        <div className="bulk-modal-body">
          <p style={{ fontSize: '0.85rem', color: '#999', marginBottom: '12px' }}>
            Select an image from the library or paste a URL. This will be applied to all selected items.
          </p>
          <ImagePicker
            value={thumbnailUrl}
            onChange={setThumbnailUrl}
            placeholder="Browse or paste thumbnail URL..."
          />

          {processing && (
            <div className="bulk-tag-progress" style={{ marginTop: '12px' }}>
              <div className="bulk-tag-progress-bar">
                <div
                  className="bulk-tag-progress-fill"
                  style={{ width: `${(progress.done / progress.total) * 100}%` }}
                />
              </div>
              <span>{progress.done} / {progress.total}</span>
              {progress.errors > 0 && (
                <span className="bulk-tag-errors">{progress.errors} errors</span>
              )}
            </div>
          )}
        </div>

        <div className="bulk-modal-footer">
          <button onClick={onClose} className="secondary" disabled={processing}>Cancel</button>
          <button onClick={handleApply} disabled={processing || !thumbnailUrl.trim()}>
            {processing ? `Processing ${progress.done}/${progress.total}...` : 'Apply Thumbnail'}
          </button>
        </div>
      </div>
    </div>
  )
}
